<div class="seds-flex seds-justify-start">
  <section tabindex="1" class="seds-flex seds-justify-start">
    <a
      class="seds-px-3 element-lg element-xl"
      [ngClass]="{ 'cursor-default': !url }"
      *ngIf="logoImage"
      [attr.href]="url"
      ><img [src]="logoImage" class="fill-white seds-mx-3" alt="Image of serasa brand"
    /></a>
    <a
      class="seds-px-2 element-xs element-sm element-md"
      [ngClass]="{ 'cursor-default': !url }"
      *ngIf="smallLogoImage"
      [attr.href]="url"
      ><img [src]="smallLogoImage" class="fill-white small-logo seds-mx-2" src="" alt="Image of serasa brand"
    /></a>
  </section>
  <section class="seds-ms-2 seds-my-auto element-lg element-xl">
    <h1
      class="seds-h1 seds-element-lg seds-element-xl seds-subtitle-1 seds-m-0 seds-font-regular color-white"
      tabindex="2"
      [attr.title]="applicationName"
      [attr.aria-label]="applicationName">
      {{ applicationName }}
    </h1>
  </section>
</div>
